import React, { FC } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { IOtherFeesFrontEndModel } from "../../../types";

const useStyles = makeStyles(() => ({
  label: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#383d4a",
    marginTop: 16,
  },
  content: {
    fontSize: 16,
    fontWeight: "normal",
    color: "#000",
    marginTop: 8,
    wordBreak: "break-word",
  },
}));

interface IViewOtherFeesProps {
  otherFees: IOtherFeesFrontEndModel[];
}

const ViewOtherFees: FC<IViewOtherFeesProps> = ({ otherFees }) => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.label}>Other Fees</div>
      {otherFees.map((f) => (
        <div key={f.name + f.amount} className={classes.content}>
          {f.name}: {f.amount}
        </div>
      ))}
    </>
  );
};

export default React.memo(ViewOtherFees);
